import { Injectable, inject } from '@angular/core';
import { BaseApiService } from '@bo/ng-api';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Tasks } from '../../_interfaces/tasks.interface';

@Injectable({
  providedIn: 'root',
})
export class TasksApiService extends BaseApiService {
  protected override http: HttpClient;

  override baseUrl: string = environment.apiRoot;
  URL_TASKS: string = 'alerts';

  constructor() {
    const http = inject(HttpClient);

    super(http);

    this.http = http;
  }

  /**
   * Get all tasks
   *
   * @return Observable<Tasks>
   */
  getAllTasks() {
    return this.http.get<Tasks>(this.getUrl(this.URL_TASKS, true));
  }
}
